export default __webpack_public_path__ + "static/media/2.cedc5662.png";